import { module } from 'stereomodularjs'

import Swiper from 'swiper';
import { Navigation, A11y, Scrollbar } from 'swiper/modules';

// configure Swiper to use modules
Swiper.use([Navigation, A11y, Scrollbar]);

export default class extends module {
  constructor(m) {
    super(m)
  }

  init() {
    this.params = {
      // Optional parameters
      direction: 'horizontal',
      loop: false,
      slidesPerView: 'auto',
      grabCursor: true,
      scrollbar: {
        el: this.el.querySelector('.swiper-scrollbar'),
        draggable: true,
      },

      //Navigation arrows
      navigation: {
        nextEl: this.el.querySelector('.swiper-button-next'),
        prevEl: this.el.querySelector('.swiper-button-prev'),
      },
      

      // a11y
      a11y: {
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide',
        paginationBulletMessage: 'Go to slide {{index}}',
        firstSlideMessage: 'This is the first slide',
        lastSlideMessage: 'This is the last slide',
      },
    }

    this.typeSlider = this.el.dataset.type

    if (this.typeSlider == 'experts') {
      this.params.navigation = false;
      this.params.breakpoints = {
        // when window width is < 320px
        0: {
          slidesPerView: 1.25,
          spaceBetween: 20
        },
        // when window width is >= 320px
        541: {
          slidesPerView: 2.25,
          spaceBetween: 30
        },
        // when window width is >= 768px
        769: {
          slidesPerView: 2,
          spaceBetween: 30
        },
        // when window width is >= 480px
        1025: {
          slidesPerView: 3,
          spaceBetween: 40
        },
        // when window width is >= 640px
        1441: {
          slidesPerView: 4,
          spaceBetween: 60
        }
      }
    } else if (this.typeSlider == 'testimonials') {
      this.params.breakpoints = {
        // when window width is < 320px
        0: {
          slidesPerView: 1,
          spaceBetween: 20
        },
        // when window width is >= 320px
        541: {
          slidesPerView: 1,
          spaceBetween: 30
        },
        // when window width is >= 768px
        769: {
          slidesPerView: 2.25,
          spaceBetween: 30
        },
        // when window width is >= 480px
        1025: {
          slidesPerView: 2.5,
          spaceBetween: 40
        },
        // when window width is >= 640px
        1900: {
          slidesPerView: 3,
          spaceBetween: 60
        }
      }
    }

    this.slider = new Swiper(this.el, this.params)

  }
}